export const environment = {
  production: false,
  appUrl: 'https://stm-dev.intentio.co.za',
  apiUrl: 'https://stm-dev.intentio.co.za/api',
  stripe: {
    publicKey:
      'pk_test_51NiCAbHBI5C1bXEzV4WioKAzRKpPIqFjuC0hYP3XtDkU8nYGYWKq0COPEOCdCp6VusBpFXGPjWCwkonItKdV1tIA00CHyuYweC'
  },
  portalConfigs: [
    { host: 'stm-prt.intentio.co.za', vno: 'MTD' },
    { host: 'stem-ireland.intentio.co.za', vno: 'stem-ie' }
  ]
};
